import {CatalogRouting} from '@aipb/gulliver/catalog/routing';
import {NibbleAction} from '@aipb/gulliver/personal-content/model';
import {openUrl} from '@aipb/shared/util/routing';
import {NibbleActionHandler} from '../nibble-action.handler';

export class CatalogNibbleActionHandler implements NibbleActionHandler {
  constructor(private catalogRouting: CatalogRouting) {
  }

  handle(nibbleAction: NibbleAction) {
    const application = nibbleAction.application;
    const nibbleCut = nibbleAction.nibbleCut;
    const serviceValue = nibbleCut.cut.serviceValue;
    const configId = nibbleCut.clientInfo.configId;

    if (application === 'catalog') {
      this.catalogRouting.detailSingle(serviceValue, configId);
    } else {
      openUrl(this.catalogRouting.detailSingleAbsUrl(serviceValue, configId));
    }
  }

  getUrl(nibbleAction: NibbleAction): string {
    const serviceValue = nibbleAction.nibbleCut.cut.serviceValue;
    const configId = nibbleAction.nibbleCut.clientInfo.configId;

    return this.catalogRouting.detailSingleAbsUrl(serviceValue, configId);
  }

  useResolver(): boolean {
    return true;
  }
}
